export default __webpack_public_path__ + "static/media/live-demo.7d02146c.png";